import React from "react";
import { useLanguage } from "../contexts/LanguageContext.jsx";
import { t } from "../utils/translations";
import ModalMotionShell from "./ModalMotionShell";

const ImpressumModal = ({ isOpen = false, onClose }) => {
  const { language } = useLanguage();
  return (
    <ModalMotionShell isOpen={isOpen} onClose={onClose} zIndexClass="z-50" backdropTintClass="bg-black/50">
      <div className="modal-container bg-white rounded-lg p-6 w-full max-w-lg shadow-xl relative" onMouseDown={(e) => e.stopPropagation()}>
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-xl font-bold"
        >
          &times;
        </button>
        <h2 className="text-lg font-semibold mb-4">{t('imprint', language)}</h2>
        <div className="text-sm text-gray-700 space-y-1">
          <p><strong>{t('legalNotice', language)}</strong></p>
          <p>Johannes Nürnberger</p>
          <p>Wilhelm-Kohlhoff-Str. 7</p>
          <p>97424 Schweinfurt</p>
          <p>E-Mail: <a href="mailto:v3tax@proton.me" className="text-blue-600 hover:underline">v3tax@proton.me</a></p>
        </div>
      </div>
    </ModalMotionShell>
  );
};

export default ImpressumModal;